export default "__VITE_ASSET__DBDfXyNc__"